import { StoreIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { useHandleMenuClick } from 'App/hooks';
import { menuSecondaryMarketplacesAppsClick } from './tracking';

const POS_URL_PATH = '/sales-channels/marketplaces';

function MarketplacesMenu() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();

  return (
    <MenuButton
      as={Link}
      to={POS_URL_PATH}
      startIcon={StoreIcon}
      onClick={() => {
        menuSecondaryMarketplacesAppsClick();
        handleClickItem();
      }}
      active={pathname === POS_URL_PATH}
      label={`${t('menu.salesChannels.more.marketplaces')}`}
    />
  );
}

export default MarketplacesMenu;
